import React from "react";
import { useLocation, useHistory } from "react-router-dom";

const PageTitle = ({ sidebar }) => {
  const location = useLocation();
  const history = useHistory();
  const currentPath = location.pathname;

  const getBreadcrumbs = (path, items, parentName = null) => {
    for (const item of items) {
      if (item.path === path) {
        return parentName ? [parentName, item.name] : [item.name];
      }
      if (item.route && item.route.length > 0) {
        const childBreadcrumbs = getBreadcrumbs(path, item.route, item.name);
        if (childBreadcrumbs.length) {
          return parentName
            ? [parentName, ...childBreadcrumbs]
            : childBreadcrumbs;
        }
      }
    }
    return [];
  };

  const breadcrumbs = sidebar.length
    ? getBreadcrumbs(currentPath, sidebar)
    : [];
  const breadcrumbTrail =
    breadcrumbs.length > 0 ? ["Dashboard", ...breadcrumbs] : ["Dashboard"];
//console.log("Breadcrumbs:", breadcrumbTrail);
  const handleNavigateFunction = (path) => {
    if (typeof path === "string" && path.trim() !== "") {
      history.push(path.toLowerCase());
    } else {
      console.error("Invalid path provided:", path);
    }
  };

  return (
    <h1 className="mt-3 text-lg font-bold text-gray-700 dark:text-gray-300">
      <nav aria-label="Breadcrumb" className="mb-2">
        <ol className="flex space-x-2 text-sm text-gray-600 dark:text-gray-400">
          {breadcrumbTrail
            .filter(
              (_, index) => index === 0 || index === breadcrumbTrail.length - 1
            )
            .map((crumb, index, filteredBreadcrumbs) => {
              const isFirst = index === 0;
              const isLast = index === filteredBreadcrumbs.length - 1;
              return (
                <React.Fragment key={index}>
                  <li
                    onClick={() =>
                      handleNavigateFunction(
                        isFirst ? "/dashboard" : currentPath
                      )
                    }
                    className={`flex items-center cursor-pointer ${
                      isFirst ? "text-gray-500" : isLast ? "text-green-500" : ""
                    }`}
                  >
                    <span>{crumb}</span>
                  </li>
                  {index < filteredBreadcrumbs.length - 1 && (
                    <span className="mx-2">/</span>
                  )}
                </React.Fragment>
              );
            })}
        </ol>
      </nav>
    </h1>
  );
};

export default PageTitle;
